import React from 'react';
import { motion } from 'framer-motion';
const audiencePoints = [{
  title: 'Enseñas uno o varios cursos',
  description: 'Necesitas encontrar rápidamente el contenido adecuado para cada nivel sin mezclar temas ni improvisar la secuencia.'
}, {
  title: 'Dedicas demasiadas horas a planificar',
  description: 'Buscas actividades, explicaciones y evaluaciones fuera del horario escolar y terminas preparando todo desde cero.'
}, {
  title: 'Tus estudiantes se pierden entre fórmulas',
  description: 'Necesitas explicar átomos, enlaces, compuestos, reacciones y cálculos mediante esquemas, ejemplos e imágenes claras.'
}, {
  title: 'Necesitas actividades diferentes',
  description: 'Quieres trabajar con formatos A y B, realizar recuperaciones y reducir la copia de respuestas entre estudiantes.'
}, {
  title: 'Quieres evaluar con mayor orden',
  description: 'Necesitas rúbricas, criterios de evaluación, proyectos y actividades integradoras ya preparados.'
}, {
  title: 'Buscas materiales que puedas reutilizar',
  description: 'Quieres organizar tu año escolar una sola vez y volver a utilizar los recursos en los próximos ciclos lectivos.'
}];
export function WhoItsFor() {
  return <section className="py-8 md:py-16 px-4" data-id="element-300" data-mp="1qx55a6wl327r">
      <div className="max-w-6xl mx-auto" data-id="element-301" data-mp="1qvu2a9aypyhp">
        <div className="max-w-4xl mx-auto text-center mb-6 md:mb-10" data-id="element-302" data-mp="1lybs6fl7ld84">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black text-slate-900 leading-tight mb-3 md:mb-4" data-id="element-303" data-mp="1lw7nhvfhka6s">
            Química Visual fue creado para docentes que necesitan enseñar mejor
            sin dedicar más horas a planificar.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-600 font-bold text-sm md:text-lg leading-relaxed" data-id="element-304" data-mp="32cjxkxdul5wj">
            Este sistema es para ti si enseñas Química en educación secundaria y
            buscas materiales claros, visuales y listos para utilizar.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-305" data-mp="3cgi9e7yfb4hv">
          {audiencePoints.map((point, index) => <motion.article key={point.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className="bg-white border border-blue-100 rounded-3xl p-5 md:p-6 shadow-lg shadow-blue-900/5" data-id="element-306" data-mp="405iqykoo8xc" data-mpi={index}>
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white text-xs font-black mb-4" data-id="element-307" data-mp="3v8t9ju1p0oca">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-slate-900 font-black text-base md:text-lg leading-tight mb-2" data-id="element-308" data-mp="2c8229hyaek8m">
                {point.title}
              </h3>
              <p className="text-slate-600 font-medium text-sm leading-relaxed" data-id="element-309" data-mp="278fpf9mdf60c">
                {point.description}
              </p>
            </motion.article>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mt-6 md:mt-10 text-center text-blue-700 font-black text-lg md:text-2xl leading-snug" data-id="element-310" data-mp="2g9no3sssu8uy">
          Si quieres entrar a tu próxima clase con la explicación, la actividad y
          la evaluación ya resueltas, este sistema es para ti.
        </motion.p>
      </div>
    </section>;
}